var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EllipsisHorizontalIcon, KeyIcon, PowerIcon, RectangleStackIcon, TrashIcon, UserIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { TfiSave } from "react-icons/tfi";
import { CHANGE_USER_STATUS, DELETE_USER, OPEN_EDIT_USER_MODAL, RESET_PASSWORD, } from "../../../constants";
import { useUserActions } from "../../../hooks/actions/useUserActions";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { UserContext } from "../../../providers/UserContextProvider";
import { WPQTDropdown, WPQTDropdownIcon, WPQTDropdownItem, } from "../WPQTDropdown";
function UserDropdown({ user }) {
    const { modalDispatch } = useContext(ModalContext);
    const { userDispatch } = useContext(UserContext);
    const { changeUserStatus, deleteUser, resetUserPassword } = useUserActions();
    const userIsActive = user.is_active;
    const openEditUserModal = (e) => {
        e.stopPropagation();
        modalDispatch({
            type: OPEN_EDIT_USER_MODAL,
            payload: user,
        });
    };
    const onChangeUserStatus = (status) => __awaiter(this, void 0, void 0, function* () {
        yield changeUserStatus(user.id, status, () => {
            userDispatch({
                type: CHANGE_USER_STATUS,
                payload: {
                    userId: user.id,
                    isActive: status,
                },
            });
        });
    });
    const onDeleteUser = (e) => __awaiter(this, void 0, void 0, function* () {
        e.stopPropagation();
        yield deleteUser(user.id, (userId) => {
            userDispatch({
                type: DELETE_USER,
                payload: userId,
            });
        });
    });
    return (_jsxs(WPQTDropdown, { menuBtn: ({ active }) => (_jsx(WPQTDropdownIcon, { isActive: active, IconComponent: EllipsisHorizontalIcon })), children: [_jsx(WPQTDropdownItem, { text: __("User details", "quicktasker"), icon: _jsx(UserIcon, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: (e) => {
                    e.stopPropagation();
                    window.location.hash = `#/users/${user.id}`;
                } }), _jsx(WPQTDropdownItem, { text: __("User tasks", "quicktasker"), icon: _jsx(RectangleStackIcon, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: (e) => {
                    e.stopPropagation();
                    window.location.hash = `#/users/${user.id}/tasks`;
                } }), _jsx(WPQTDropdownItem, { text: __("Edit user", "quicktasker"), icon: _jsx(TfiSave, { className: "wpqt-icon-blue wpqt-size-3" }), onClick: openEditUserModal }), user.has_password && (_jsx(WPQTDropdownItem, { text: __("Reset password", "quicktasker"), icon: _jsx(KeyIcon, { className: "wpqt-icon-red wpqt-size-4" }), onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.stopPropagation();
                    yield resetUserPassword(user.id, () => {
                        userDispatch({
                            type: RESET_PASSWORD,
                            payload: user.id,
                        });
                    });
                }) })), userIsActive && (_jsx(WPQTDropdownItem, { text: __("Disable user", "quicktasker"), icon: _jsx(PowerIcon, { className: "wpqt-icon-red wpqt-size-4" }), className: "!wpqt-mb-0", onClick: (e) => {
                    e.stopPropagation();
                    onChangeUserStatus(false);
                } })), !userIsActive && (_jsxs(_Fragment, { children: [_jsx(WPQTDropdownItem, { text: __("Activate user", "quicktasker"), icon: _jsx(PowerIcon, { className: "wpqt-icon-green wpqt-size-4" }), onClick: (e) => {
                            e.stopPropagation();
                            onChangeUserStatus(true);
                        } }), _jsx(WPQTDropdownItem, { text: __("Delete user", "quicktasker"), icon: _jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-4" }), onClick: onDeleteUser })] }))] }));
}
export { UserDropdown };
